import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { DynamicValueInput } from './LoanActionItems';

const LoanActionMismoDocumentRow = ({ index, rootPath, isDisabled, isEditAllowed, options }) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <div>
      <DynamicValueInput
        required
        disabled={isDisabled || !isEditAllowed}
        label="MISMO Document Type"
        name={`${fieldPath}.documentType`}
        options={options}
        type={FieldTypesEnum.SELECT}
      />
    </div>
  );
};

LoanActionMismoDocumentRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  options: PropTypes.array.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
};

export default memo(LoanActionMismoDocumentRow);
